exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".portal{min-height:100px;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:5px 0}.portal,.portal .element{display:-webkit-box;display:-ms-flexbox;display:flex}.portal .element{border:1px dotted #888;border-radius:2px;padding:20px 30px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2;-ms-flex-preferred-size:0;flex-basis:0}.portal .spinner{position:absolute}.portal .gap{-webkit-box-flex:1;-ms-flex:1 0 10px;flex:1 0 10px}.focus{display:block;font-weight:700}.portal .element p{text-align:center}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/game-elements/portal/portal.component.css
// module id = 498
// module chunks = 1